import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.css']
})
export class MessageDialogComponent implements OnInit {
  @Input() title: string;
  @Input() message: string = '';

  @Input() callback: any;
  @Input() cancel: false;
  @Input() changeAccount: any;
  @Input() txtOk: string=undefined;
  @Input() txtCancel: string=undefined;
  @Input() multiline: false;
  msgCss = '';
  showChangeAccount = false;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.msgCss = (this.multiline ? '' : 'modal-body-pre-wrap');
    this.showChangeAccount = typeof (this.changeAccount) === 'function';
  }

  async onCancel() {
    //Close dialog
    await this.activeModal.close(undefined);
  }

  async onOk() {
    //Close dialog
    await this.activeModal.close(undefined);
    if (typeof (this.callback) == 'function') this.callback();
  }

  async onChangeAccount() {
    //Close dialog
    await this.activeModal.close(undefined);
    this.changeAccount();
  }
}
